document.addEventListener('DOMContentLoaded', () => {
    // Check if screen width is less than 999px
    if (window.innerWidth <= 999) {
        const header = document.querySelector('.header');
        if (!header) return;

        const toggleIsSolidForHeader = () => {
            header.classList.add('is-solid');

            if (window.scrollY >= 0) {
                header.classList.add('scrolled');
            } else {
                header.classList.remove('scrolled');
            }
        };

        toggleIsSolidForHeader();

        document.addEventListener('scroll', toggleIsSolidForHeader);
    }


    document.addEventListener('click', function(e){
        if (e.target.closest('.show-popup_on_click')) {
            console.log("clicked")
            console.log(e.target, 'target got')
            let atcBtn = e.target;
            let atcPopup = document.querySelector('.atc-popup');
            let closeatcPopupBtn = document.querySelector('.close-atc_popup');
            console.log("atcPopup", atcPopup)

            setTimeout(() => {
                const qtyErr = atcBtn.closest('.show-popup_on_click').querySelector('.banner--error');
                let atcPopup = document.querySelector('.atc-popup');
                console.log("atcPopup", atcPopup);
                
                if (qtyErr) {
                    console.log("Product don't have qty");
                    return;
                } else {
                    atcPopup.classList.add('active');
                }
            }, 1000);

            atcPopup?.addEventListener('click', () => {
                atcPopup.classList.remove('active')
        
            })
        
            closeatcPopupBtn?.addEventListener('click', () => {
                atcPopup.classList.remove('active')
        
            })
        }
    })


    // document.querySelectorAll('.collection-grid_atc_button').forEach((btn)=>{
    //     btn.addEventListener('click', ()=>{
    //         let atcBtn = btn;
    //         let atcPopup = document.querySelector('.atc-popup');
    //         let closeatcPopupBtn = document.querySelector('.close-atc_popup');

    //         setTimeout(() => {
    
    //             if (qtyErr) {
    //                 console.log("Product don't have qty")
    //                 return
    //             } else {
    //                 atcPopup.classList.add('active')
    //             }
    //         }, 1000);
    //         atcPopup?.addEventListener('click', () => {
    //             atcPopup.classList.remove('active')
        
    //         })
        
    //         closeatcPopupBtn?.addEventListener('click', () => {
    //             atcPopup.classList.remove('active')
        
    //         })
    //     })
    // })

    function collPrdPopup(){
        document.querySelectorAll('.collection-grid_atc_button').forEach((btn) => {
            btn.addEventListener('click', () => {
                setTimeout(() => {
                    const wrapper = btn.closest('.show-popup_on_click');
                    const qtyValue = parseInt(wrapper?.dataset.qty || "1", 10); // fallback = 1
        
                    if (qtyValue > 0) {
                        atcPopup?.classList.add('active');
        
                        const image = btn.getAttribute('data-image');
                        const title = btn.getAttribute('data-title');
                        const price = btn.getAttribute('data-price');
        
                        const popupImage = document.querySelector('#main-product-image');
                        const popupTitle = document.querySelector('#main-product-title');
                        const popupPrice = document.querySelector('#main-product-price');
        
                        if (popupImage && image) {
                            popupImage.src = image;
                            popupImage.alt = title;
                        }
        
                        if (popupTitle && title) {
                            popupTitle.textContent = title;
                        }
        
                        if (popupPrice && price) {
                            popupPrice.textContent = price;
                        }
        
                    } else {
                        console.log("Out of stock product clicked.");
                        atcPopup?.classList.remove('active');
                    }
                }, 1000);
            });
        });
        
    }
    collPrdPopup();

    // let atcBtn = document.querySelector('.show-popup_on_click');
    // let atcPopup = document.querySelector('.atc-popup');
    // let closeatcPopupBtn = document.querySelector('.close-atc_popup');
    // console.log("atc btn", atcBtn);

    // function showPopup(){
    //     atcBtn.addEventListener('click', () => {
    //         console.log('clicked')
    //         setTimeout(() => {
    //             const qtyErr = atcBtn.querySelector('.banner--error')
    
    //             if (qtyErr) {
    //                 console.log("dont have qty")
    //                 return
    //             } else {
    //                 atcPopup.classList.add('active')
    //             }
    //         }, 1000);
    //     })
    // }
    // showPopup();
    // atcPopup?.addEventListener('click', () => {
    //     atcPopup.classList.remove('active')

    // })

    // closeatcPopupBtn?.addEventListener('click', () => {
    //     atcPopup.classList.remove('active')

    // })

    // document.querySelectorAll('.collection-grid_atc_button').forEach((collAtcBtn) => {
    //     collAtcBtn.addEventListener('click', () => {
    //         const variantId = collAtcBtn.getAttribute('data-variant-id'); // Get the variant ID from data-attribute
    //         addMyProducttoCart(variantId); // Call the function with the variantId
    //     });
    // });
    
    // // Function to add product to cart
    // async function addMyProducttoCart(variantId) {
    //     console.log('variantId: ', variantId);
        
    //     let formData = {
    //         items: [{
    //             id: variantId,
    //             quantity: 1
    //         }]
    //     };
    
    //     try {
    //         const response = await fetch('/cart/add.js', {
    //             method: 'POST',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //             },
    //             body: JSON.stringify(formData)
    //         });
    
    //         const data = await response.json();
    
    //         if (data && data.items) {
    //             const drawer = document.querySelector('.header__cart-dot');
    
    //             // If the drawer is not already active, activate it
    //             if (!drawer.classList.contains('is-visible')) {
    //                 drawer.classList.remove("is-empty");
    //                 drawer.classList.add("is-visible");
    
    //                 const body_overflow = document.querySelector('body');
    //             }
    
    //             // Refresh the cart contents
    //             $('.header__cart-dot').load(location.href + ' #CartDrawer');
    //             $('#cart-icon-bubble').load(location.href + ' #cart-icon-bubble');
    //         }
    //     } catch (error) {
    //         console.error('Error: ', error);
    //     }
    // }
    
      
});

